// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1pASA","bigColWidth":"Table_bigColWidth__3k66X","biggerColWidth":"Table_biggerColWidth__3dOY2","row":"Table_row__1K6Tc","col":"Table_col__1DoXa"};